var React = require('react');

function T1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"T1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"44.17 1.78 22.73 0.9 0.95 0 0 23.05 20.97 23.92 44.02 24.87 64.99 25.73 65.94 2.68 44.17 1.78","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":1},React.createElement("rect",{"x":"24.79","y":"20","width":"23.07","height":"62.88","transform":"translate(-4.69 3.65) rotate(-5.41)","fill":"#73c9bd"}))])]);
}

T1.defaultProps = {"viewBox":"0 0 65.94 83.83"};

module.exports = T1;

T1.default = T1;
